var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64286 37.3571L10.3571 35.2357C13.1214 36.9714 16.4643 38 20 38C29.9643 38 38 29.9643 38 20C38 10.0357 29.9643 2 20 2C10.0357 2 2 10.0357 2 20C2 23.5357 3.02857 26.8786 4.76429 29.6429L2.64286 37.3571Z",
    fill: "#43D854",
    stroke: "white",
    strokeWidth: 3.21429,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9372 24.8855C27.7158 27.4569 25.4658 27.7783 25.4658 27.7783C23.5372 28.164 21.0944 27.3283 19.1658 26.4283C16.4015 25.1426 14.0229 23.0855 12.4158 20.4498C11.7087 19.2283 11.0658 17.814 11.0015 16.464C11.0015 16.464 10.7444 14.214 12.9301 12.414C13.1229 12.2855 13.3158 12.2212 13.5729 12.2212H14.5372C14.9229 12.2212 15.3087 12.4783 15.4372 12.864L16.9158 16.464C17.0444 16.8498 16.9801 17.2355 16.7229 17.5569L15.7587 18.5855C15.4372 18.9069 15.4372 19.3569 15.6301 19.7426C15.6944 19.8712 15.8229 20.0641 16.0158 20.2569C17.1729 21.7998 18.7158 22.9569 20.4515 23.7283C20.7087 23.8569 20.9015 23.9212 21.0944 23.9855C21.5444 24.114 21.9301 23.9212 22.1872 23.5998L22.9587 22.4426C23.1515 22.1212 23.5372 21.9283 23.9229 21.9926L27.7801 22.5712C28.1658 22.6355 28.4872 22.9569 28.6158 23.3426L28.8729 24.3069C29.0015 24.4355 29.0015 24.6926 28.9372 24.8855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.9562abed9e6a942d67d11aab53a7a671.svg";
export { ForwardRef as ReactComponent };